(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flexi-featured-hero-images-3"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let images = document.querySelectorAll('.flexi-featured-img, .flexi-featured-placeholder-img');
    let currentIndex = 0;

    images[0].style.display = 'block';

    function showNextImage() {
      images[currentIndex].style.display = 'none';
      images[currentIndex].classList.remove('flexi-featured-image-fade');

      currentIndex = (currentIndex + 1) % images.length;
      images[currentIndex].style.display = 'block';
      images[currentIndex].classList.add('flexi-featured-image-fade');

      let loadingBar = document.querySelector('.flexi-loading-bar');
      loadingBar.style.animation = 'none';
      loadingBar.offsetHeight;
      loadingBar.style.animation = '';
    }

    setInterval(showNextImage, 3000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
